import axios from 'axios';

const API_URL = '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const user = localStorage.getItem('user');
    if (user) {
      const { token } = JSON.parse(user);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Helper para extraer un mensaje de error legible de una respuesta de la API
export const extractErrorDetails = (error, defaultMessage = 'Error desconocido') => {
  const message = error.response?.data?.message || defaultMessage;
  return { message };
};

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },
};

export const userService = {
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  toggleUserStatus: async (id) => {
    const response = await api.put(`/users/${id}/toggle-status`);
    return response.data;
  },
};

export const chequeService = {
  getCheques: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.numero) params.append('numero', filters.numero);
    if (filters.fromFechaEmision) params.append('fromFechaEmision', filters.fromFechaEmision);
    if (filters.toFechaEmision) params.append('toFechaEmision', filters.toFechaEmision);
    if (filters.fromFechaVencimiento) params.append('fromFechaVencimiento', filters.fromFechaVencimiento);
    if (filters.toFechaVencimiento) params.append('toFechaVencimiento', filters.toFechaVencimiento);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortDirection) params.append('sortDirection', filters.sortDirection);
    if (filters.page !== undefined) params.append('page', filters.page);
    if (filters.size) params.append('size', filters.size);

    const response = await api.get(`/cheques?${params.toString()}`);
    return response.data;
  },

  getChequeById: async (id) => {
    const response = await api.get(`/cheques/${id}`);
    return response.data;
  },

  createCheque: async (chequeData) => {
    const response = await api.post('/cheques', chequeData);
    return response.data;
  },

  updateCheque: async (id, chequeData) => {
    const response = await api.put(`/cheques/${id}`, chequeData);
    return response.data;
  },

  deleteCheque: async (id) => {
    const response = await api.delete(`/cheques/${id}`);
    return response.data;
  },

  getDashboard: async (fromDate, toDate, page = 0, size = 20) => {
    const response = await api.get(`/cheques/dashboard?fromDate=${fromDate}&toDate=${toDate}&page=${page}&size=${size}`);
    return response.data;
  },
};
